import { render, staticRenderFns } from "./SurveyTypeEdit.vue?vue&type=template&id=62da33e3&"
import script from "./SurveyTypeEdit.vue?vue&type=script&lang=js&"
export * from "./SurveyTypeEdit.vue?vue&type=script&lang=js&"
import style0 from "./SurveyTypeEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports